import { render, staticRenderFns } from "./CardCalendarEventInfo.vue?vue&type=template&id=6b204198&scoped=true"
import script from "./CardCalendarEventInfo.js?vue&type=script&lang=js&external"
export * from "./CardCalendarEventInfo.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b204198",
  null
  
)

export default component.exports